import React, { useState, useEffect, useContext } from "react";
import {
  CalculatorIcon,
  DeleteIcon,
} from "assests/GmsIcons";
import { SB3RuleContext } from "../Rules/SB3RuleContext";
import LogicRuleMathTextAreaComponent from "./LogicRuleMathTextAreaComponent";
import { OPERATORS } from "./constants";

type LogicRuleMathExpComponentPropType = {
  index: number;
  data: any;
  rootIndex: number
};

const LogicRuleMathExpComponent = ({ data, index, rootIndex }: LogicRuleMathExpComponentPropType) => {
  const { openPickPanel, deleteLogicalCondtion, updateLogicalOperator, logicRule, selectedObj } = useContext(SB3RuleContext);
  const [linkCss, setLinkCss] = useState('tw-h-9 tw-bg-white')

  useEffect(() => {
    console.log("CHANGE")
    const css = `tw-h-9 ${(selectedObj?.selectedConditionIndex === index && selectedObj?.selectedRootIndex === rootIndex) ? 'tw-bg-indigo-100' : 'tw-bg-gray-100'}`
    setLinkCss(css)
  }, [openPickPanel])
  const getValue = () => {
    try {
      return logicRule.rule.source[rootIndex].condition[index].rule.operator;
    } catch (error) {
      return ''; // return an empty string or handle error as needed
    }
  }
  return (
    <div className="sub-condition">
      <div className="left-rule-parenthesis" />
      <div className="tw-flex tw-w-[670px] tw-m-3">
        <LogicRuleMathTextAreaComponent nodes={data?.rule?.left_exp} rootIndex={rootIndex} index={index} type="left_exp" />
        <button className={selectedObj?.type === 'left_exp' ? linkCss : "tw-h-9 tw-bg-gray-100"} onClick={() => {
          openPickPanel("left_exp", index, rootIndex);
        }}>
          <CalculatorIcon />
        </button>
        <select
          value={getValue()}
          onChange={(e) => { updateLogicalOperator(rootIndex, index, "source", e.target.value) }}
          className="tw-w-[100px] tw-h-9 tw-px-2.5 tw-py-2 tw-bg-white tw-rounded tw-border tw-border-zinc-200 tw-gap-2.5">
          {OPERATORS.map((op, opIndex) => <option key={opIndex} value={op}>
            {op}
          </option>)}  
        </select>
      </div>

      <div className=" tw-mt-20 tw-flex">
        <LogicRuleMathTextAreaComponent nodes={data?.rule?.right_exp} rootIndex={rootIndex} index={index} type="right_exp" />
        <button className={selectedObj?.type === 'right_exp' ? linkCss : "tw-h-9 tw-bg-gray-100"} onClick={() => {
          openPickPanel("right_exp", index, rootIndex);
        }}>
          <CalculatorIcon />
        </button>
      </div>
      <button onClick={() => deleteLogicalCondtion(rootIndex, index)} className="tw-mt-4">
        <DeleteIcon />
      </button>
      <div className="right-math-rule-parenthesis" />
    </div>

  );
};

export default LogicRuleMathExpComponent;
